import type { InputHTMLAttributes, ReactNode } from "react";
import { useId } from "react";

interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "id"> {
  label: string;
  helper?: ReactNode;
  error?: string | null;
}

export function TextInput({
  label,
  helper,
  error,
  ...rest
}: TextInputProps): JSX.Element {
  const inputId: string = useId();
  const helperId: string = `${inputId}-helper`;
  const hasError: boolean = error != null && error !== "";
  return (
    <div className={`field${hasError ? " field--error" : ""}`}>
      <label htmlFor={inputId} className="field__label">
        {label}
      </label>
      <input
        id={inputId}
        className="field__input"
        aria-invalid={hasError || undefined}
        aria-describedby={helper || hasError ? helperId : undefined}
        {...rest}
      />
      {hasError ? (
        <p id={helperId} className="field__error" role="alert">
          {error}
        </p>
      ) : helper ? (
        <p id={helperId} className="field__helper">
          {helper}
        </p>
      ) : null}
    </div>
  );
}
